import Admin from "./Admin.js";
export default Admin;
